import reduce from 'lodash/reduce';
export const _reduce = reduce;
